import Rest from '../Rest'

export default class InfluencerLevelService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/influencer_levels'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
